module.exports = __webpack_public_path__ + "static/img/xfzmh5.fad0cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xfzmh5.png
// module id = qPdT
// module chunks = 0